import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./globalStyles.css";
import Theme from "./asset/Theme/Theme";

import { Login } from "./pages/User/Login";
import SignUp from "./pages/User/SignUp";
import ForgotPassword from "./pages/User/ForgotPassword";
import ResetPassword from "./pages/User/ResetPassword";
import { DashBoard } from "./pages/dashBoard/DashBoard";
import UserProfile from "./pages/UserProfile";
import Transactions from "./pages/transactions/Transactions";
import EditProfile from "./pages/editprofile/EditProfile";

import { OderManagement } from "./pages/orderManagement/OderManagement";

import { ClientManagement } from "./pages/clientmanagement/ClientManagement";
import { BannerManagement } from "./pages/bannermanagement/BannerManagement";
import { SalesManagement } from "./pages/salesManagement/salesManagement"
import { BackendUser } from "./pages/backenduser/BackendUser";
import { BrandManagement } from "./pages/brandmanagement/BrandManagement";
import { DiscountCoupon } from "./pages/discountCoupon/DiscountCoupon";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getUserByToken } from "./actions/userAuth";
import { logoutUser } from "./utils/api";
import { TicketManagement } from "./pages/ticketManagement/TicketManagement";
import { RewardManagement } from "./pages/rewardManagement/RewardManagement";
import ClientDetails from "./pages/clientmanagement/ClientDetails";
import Lead from "./pages/Lead";
import CampaignLeads from "./pages/CampaignLeads/CampaignLeads";
import UsersTab from "./pages/backenduser/UserTab";
import BudgetreeLeads from "./pages/budgetree leads/BudgetreeLeads";
import Brand from "./pages/brandmanagement/Brand";
import Settings from "./pages/settings/Settings";
import SupportQuery from "./pages/supportQuery/SupportQuery";
import RefundManagement from "./pages/refundManagement/RefundManagement";
import RevenueAnalytics from "./pages/analytics/RevenueAnalytics";
import UsersOrdersPage from "./pages/usersOrders/UsersOrdersPage";
import ExperiencesManagement from "./pages/experiences/ExperiencesManagement";
import FeaturedVoucher from "./pages/featuredVoucher/FeaturedVoucher";

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      dispatch(
        getUserByToken(
          (data) => {
            const user =
              data?.data?.data ?? data?.data ?? data ?? {};
            dispatch({
              type: "LOG_IN",
              payload: user,
            });
          },

          (err) => {
            console.log(err);
            if (err?.response?.status === 401 || err?.response?.data?.statusCode === 401) {
              logoutUser();
            }
          },
          localStorage.getItem("token")
        )
      );
    }
  }, [dispatch]);

  return (
    <Theme>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/user" element={<UserProfile />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/edit-profile" element={<EditProfile />} />

          <Route path="order-management" element={<OderManagement />} />
          <Route path="brand-management" element={<Brand />} />
          <Route path="discount-coupon" element={<DiscountCoupon />} />
          <Route path="/business-user" element={<ClientManagement />} />
          <Route path="Banner-management" element={<BannerManagement />} />
          <Route path="/backend-user" element={<UsersTab />} />
          <Route path="ticket-management" element={<TicketManagement />} />
          <Route path="sales-management" element={<SalesManagement />} />
          <Route path="reward-management" element={<RewardManagement />} />
          <Route path="/client-detail/:id" element={<ClientDetails />} />
          <Route path="/campaign-leads" element={<CampaignLeads />} />
          <Route path="/budgetree-leads" element={<BudgetreeLeads />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/support-query" element={<SupportQuery />} />
          <Route path="/refund-management" element={<RefundManagement />} />
          <Route path="/revenue-analytics" element={<RevenueAnalytics />} />
          <Route path="/user-orders" element={<UsersOrdersPage />} />
          <Route path="/users-orders" element={<UsersOrdersPage />} />
          <Route path="/blacklist" element={<UserProfile defaultTab={2} />} />
          <Route path="/user-blacklist" element={<UserProfile defaultTab={2} />} />
          <Route path="/fraud-users" element={<UserProfile defaultTab={2} />} />
          <Route path="/experiences" element={<ExperiencesManagement />} />
          <Route path="/experiences/orders" element={<ExperiencesManagement defaultTab={1} />} />
          <Route path="/featured-voucher" element={<FeaturedVoucher />} />
        </Routes>
      </BrowserRouter>
    </Theme>
  );
}
